/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiEmailDtoEmailContentDto
 */
export interface WebApiEmailDtoEmailContentDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiEmailDtoEmailContentDto
     */
    subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiEmailDtoEmailContentDto
     */
    content?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiEmailDtoEmailContentDto
     */
    attachmentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiEmailDtoEmailContentDto
     */
    date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiEmailDtoEmailContentDto
     */
    email?: string | null;
}

/**
 * Check if a given object implements the WebApiEmailDtoEmailContentDto interface.
 */
export function instanceOfWebApiEmailDtoEmailContentDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiEmailDtoEmailContentDtoFromJSON(json: any): WebApiEmailDtoEmailContentDto {
    return WebApiEmailDtoEmailContentDtoFromJSONTyped(json, false);
}

export function WebApiEmailDtoEmailContentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiEmailDtoEmailContentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'attachmentCount': !exists(json, 'attachmentCount') ? undefined : json['attachmentCount'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function WebApiEmailDtoEmailContentDtoToJSON(value?: WebApiEmailDtoEmailContentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subject': value.subject,
        'content': value.content,
        'attachmentCount': value.attachmentCount,
        'date': value.date,
        'email': value.email,
    };
}

